export default __webpack_public_path__ + "static/media/712.72977073.jpg";